import { Component, DestroyRef, signal, inject, OnInit, TemplateRef, ViewChild, ViewEncapsulation, WritableSignal, AfterViewInit, computed, Output, EventEmitter } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { DIALOG_TYPES } from 'countable@helpers';
import { SPIN_STYLES, SpinInputModel, UserDetailModel } from 'countable@model';
import { ToastrService } from 'ngx-toastr';
import { combineLatest, delay, forkJoin, map, Observable, of, tap } from 'rxjs';
import { BillingModel } from 'src/app/model/billing/billing.model';
import { FirmModel } from 'src/app/model/firm/firm.model';
import { BillingService } from 'src/app/services/billing.service';
import { FirmService } from 'src/app/services/firm.service';
import { AclModel } from '../../../model/acl.model';
import { AclService } from '../../../services/acl.service';
import { AuthService } from '../../../services/auth.service';
import { ClientService } from '../../../services/client.service';
import { UserService } from '../../../services/user.service';
import { SharedService } from '../../shared/shared.service';
import { finalize } from 'rxjs';
import { RemoveAndReassignFlexComponent } from '../../remote-shared/remove-and-reassign-flex/remove-and-reassign-flex.component';
import { ClientModel } from 'src/app/model/client/client.model';
import { EngService } from 'src/app/services/eng.service';
import { ClientAssignedPartnerModel } from 'src/app/model/client/client-assigned-partner.model';
import { ClientAssignedTeamModel } from 'src/app/model/client/client-assigned-team.model';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTableModule} from '@angular/material/table';
import { SpinDirective } from 'src/app/directives/spin.directive';
import { MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SettingsOverlayInput } from 'src/app/model/settings-overlay-input.model';
import { TimeAgoPipe } from 'src/app/helpers/time-ago.pipe';


@Component({
  selector: 'app-user-teamaccess',
  templateUrl: './teamaccess.component.html',
  styleUrls: ['./teamaccess.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, MatMenuModule, ReactiveFormsModule, FormsModule, MatFormFieldModule, MatInputModule, MatButtonModule,
    MatSortModule, MatTabsModule, MatDialogModule, MatTableModule, SpinDirective, TimeAgoPipe],
  standalone: true
})

export class UserTeamAccessComponent implements OnInit, AfterViewInit {
  @ViewChild('teamMembersSort') teamMembersSort: MatSort;
  @ViewChild('clientMembersSort') clientMembersSort: MatSort;
  @ViewChild('deleteClientDialog') deleteClientDialog: TemplateRef<any>;
  @ViewChild('alertDeleteClientDialog') alertDeleteClientDialog: TemplateRef<any>;
  @ViewChild('alertArchiveClientDialog') alertArchiveClientDialog: TemplateRef<any>;
  @ViewChild('alertUnArchiveClientDialog') alertUnArchiveClientDialog: TemplateRef<any>;

  @Output() toggleSettingsOverlay = new EventEmitter<SettingsOverlayInput>();

  loggedInUserDetails: UserDetailModel;
  getAccessTypeData: any;
  teamAccessData: any;
  isEditAccessType: any;
  noFirmTeamAccessDetailsFound: boolean;
  accessType: any;
  datasourceMap: Map<number, ClientModel> = new Map<number, ClientModel>();
  datasource: MatTableDataSource<ClientModel> = new MatTableDataSource<ClientModel>([]);
  teamAccessDataCopy: any;
  clientsDataCopy: any;
  teamMembers: any;
  clients: any;
  tabIndexValue = 0;
  countsFromApi:  WritableSignal<any[]> = signal<any[]>([]);
  acl: AclModel;
  userAccessActions: any;
  warningMessage: string;
  clientName: any;
  clientFirmId: any;
  clientId: any;
  isStatusEdit: any;
  isDelete: number;
  bodyMessage: string;
  firm: FirmModel;
  billing: BillingModel;
  isFirmHealthyAndHasEditAccess: boolean = false;
  displayedColumnsTeams: string[] = ['title', 'fullname', 'email', 'useraccessname', 'lastloggedin', 'status', 'actions'];
  displayedColumnsClients: string[] = [ 'entityName', 'email', 'lastloggedin', 'status', 'actions'];
  public spinnerConfig: WritableSignal<SpinInputModel> = signal<SpinInputModel>(new SpinInputModel(null,SPIN_STYLES.SPIN));
  public spinnerConfigTab: WritableSignal<SpinInputModel> = signal<SpinInputModel>(new SpinInputModel(null,SPIN_STYLES.LINE));
  private spinCount: number = 0;
  private destroyRef = inject(DestroyRef);
  partnersAssigned: Map<number, ClientAssignedPartnerModel> = new Map<number, ClientAssignedPartnerModel>();
  teamAssigned: Map<number, ClientAssignedTeamModel> = new Map<number, ClientAssignedTeamModel>();
  unassignedClientsId: Set<number> = new Set<number>();
  selectedClient: ClientModel = null;
  clientsCount: WritableSignal<number> = signal<number>(0);
  
  totalCount = computed(() => {
    const clientCount = this.clientsCount(); // Clients Count
    const countDataArray = this.countsFromApi();
    const countData = countDataArray?.[0];
    const paidCount = Number(countData?.paid) || 0; // Team Members Count
    return clientCount + paidCount;
  });

  constructor(private authService: AuthService, private aclService: AclService,
              private router: Router, private sharedService: SharedService, private engService: EngService,
              private toastr: ToastrService, public dialog: MatDialog, private firmService: FirmService, 
              private billingService: BillingService, private userApiService: UserService, private clientService: ClientService) {  
  }

  ngOnInit() {
    combineLatest([
      this.authService.subjectUserDetail,
      this.aclService.subject,
      this.firmService.subject,
      this.billingService.subject
    ]).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([user, acl, firm, billing]) => {
        if (!user || !firm || !billing || !acl) {
          this.authService.logout();
          return;
        }
        this.loggedInUserDetails = user;
        this.getTeamAccessData();
        this.loadClientsData();
        this.getAccessTypeDetails();
        this.acl = acl;
        this.firm = firm;
        this.billing = billing;
        this.acl.hasUserAdd = !!(this.acl.hasClientAdd && this.acl.hasTeamMemberAdd);
        this.isFirmHealthyAndHasEditAccess = !firm.isPaused && !firm.isDeleteInProgress && acl.hasClientEdit;
      });
    localStorage.removeItem('settingsUserAccessClient');
    localStorage.removeItem('settingsUserAccess');
    localStorage.removeItem('teamMemberData');
    localStorage.removeItem('settingsUserAccessTeamMemberData');
    localStorage.removeItem('settingsUserAccessClientData');
  }

    ngAfterViewInit() {
    this.datasource.sort = this.clientMembersSort;
     // Custom sorting function for Name and Status only
    this.datasource.sortingDataAccessor = (data: any, sortHeaderId: string) => {
      switch (sortHeaderId) {
        case 'entityName':
          return data.entityName?.toLowerCase() || '';
        case 'status':
          return data.isArchived ? 'archived' : 'active';
        default:
          return data[sortHeaderId];
      }
    }
  }

  // get access type details drop down
  getAccessTypeDetails() {
    this.updateSpinnerConfig(true);
    this.userApiService.getAllUserAccessType().pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res) {
          const accessTypeData = JSON.parse(res);
          this.getAccessTypeData = accessTypeData.Accesstype;
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  // getting team access details
  getTeamAccessData() {
    this.updateSpinnerConfig(true);
    this.firmService.getFirmPartnerTeamAccess().pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res && res['countdata'] != undefined && res['data'] != undefined) {
          this.countsFromApi.set(res['countdata'] || []);
          this.teamAccessData = res['data'];
          this.teamAccessDataCopy = res['data'];
          this.clientsDataCopy = res['clientdata'];
          this.accessType = res['access'];
          this.isEditAccessType = this.accessType.IsAddEditDelete;
          this.userAccessActions = this.accessType;
          if (this.tabIndexValue == 0) {
            this.bindMatGrid(this.teamAccessData, 'ALL');
          }
        } else {
          this.toastr.info('No data available!');
        }
      },
      error: error => {
        this.toastr.error(error.error);
      }
    });
  }

  saveTeamUserStatus(userId: number, activate: boolean) {
    if (this.isEditAccessType == 0) {
      return;
    }
    this.updateSpinnerConfig(true);
    this.firmService.changeTeamMemberStatus({
      member: userId,
      mode: activate ? 'ENABLE' : 'DISABLE'
    }).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe(res => {
      if (res.status === 200) {
        this.getTeamAccessData();
        this.loadClientsData();
        this.toastr.success(activate ?
          'Granted access for user successfully' :
          'Removed access for user successfully'
        );
      } else {
        res.errors.forEach(error => { this.toastr.error(error); });
      }
    });
  }

  changeClientArchiveStatus(archived: boolean): void {
    this.clientService.changeClientArchiveStatus(this.clientFirmId, archived).subscribe(res => {
      if (res.status === 200) {
        this.getTeamAccessData();
        this.loadClientsData();
        this.toastr.success(`Client ${archived ? 'archived' : 'unarchived'} successfully`);
      } else {
        res.errors.forEach(error => { this.toastr.error(error); });
      }
    });
  }

  showArchiveClientDecisionDialog(element: ClientModel, archive: boolean = false) {
    if (element) {
      this.clientFirmId = element.clientFirm;
      // this.clientId = element.useraccountid;
      this.clientName = element.entityName;
    }
    this.warningMessage = 'Do you wish to continue?';
    if (archive) {
      this.dialog.open(this.alertArchiveClientDialog).afterClosed().subscribe();
    } else {
      this.dialog.open(this.alertUnArchiveClientDialog).afterClosed().subscribe();
    }
  }

  deleteClientWarning(client: ClientModel) {
    this.selectedClient = client;
    this.clientFirmId = client.clientFirm;
    this.clientName = client.entityName;

    if (!client.isArchived) {
      // Case 1: Client is not archived → prompt to archive
      this.dialog.open(this.alertArchiveClientDialog).afterClosed().subscribe();
      return;
    }

    if (client.engCount === 0) {
      // Case 2: Archived and has no engagements → allow permanent delete
      this.bodyMessage = `All data related to client ${this.clientName} will be permanently deleted.`;
      this.warningMessage = 'Do you wish to continue?';
      this.dialog.open(this.deleteClientDialog).afterClosed().subscribe();
      return;
    }

    // Case 3: Archived but has engagements → cannot delete
    this.selectedClient = null;
    this.dialog.open(this.alertDeleteClientDialog).afterClosed().subscribe();
  }

  deleteClient() {
    this.updateSpinnerConfig(true);
    this.clientService.deleteClient({
      'clientFirm': this.selectedClient.clientFirm,
      'isArchived': this.selectedClient.isArchived
    }).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe(res => {
      if (res.status === 200) {
        this.toastr.success('Client record deleted successfully');
        this.getTeamAccessData();
        this.loadClientsData();
      } else {
        res.errors.forEach(msg => this.toastr.error(msg));
      }
    }).add(() => {
      this.engService.refreshAiEngagements$.next(true);
    });

  }

  deleteTeamMember(element) {
    this.updateSpinnerConfig(true);
    this.firmService.deleteTeamMember(element.useraccountid).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe(res => {
      if (res.status === 200) {
        this.toastr.success('Team member deleted successfully');
        this.getTeamAccessData();        
        this.loadClientsData();
        this.firmService.getTeamCountForBilling(true).subscribe();
      } else {
        res.errors.forEach(error => { this.toastr.error(error); });
      }
    }).add(() => {
      this.firmService.getTeamCountForBilling(true);
    });
  }

  updateMember(data) {
    localStorage.setItem('settingsUserAccess', 'Success');
    localStorage.setItem('settingsUserAccessTeamMemberData', JSON.stringify(data));
    this.router.navigate(['/dashboard/members/team/add']);
    this.toggleSettingsOverlay.emit({isDisplay: false, tabIndex: 0});
  }

  updateClient(client: ClientModel) {
    this.clientService.selectedClient.next(client);
    this.router.navigate([`/dashboard/members/clients/i`])
      .then(() => {
        this.engService.engNavigationStarted$.next(null);
      });
    this.toggleSettingsOverlay.emit({isDisplay: false, tabIndex: 0});
  }

  trackTeamAccessDetails(index) {
    return index;
  }

  trackClientAccessDetails(index) {
    return index;
  }

  applyFilter(event) {
    let filterData;
    if (this.tabIndexValue === 0) {
      filterData = this.teamMembers;
    } else if (this.tabIndexValue === 1) {
      filterData = this.clients;
    }
    const filterValue = (event.target as HTMLInputElement).value;
    filterData.filter = filterValue.trim().toLowerCase();
    this.noFirmTeamAccessDetailsFound = filterData.filteredData.length <= 0;
  }

  addTeamMember() {
    if (this.loggedInUserDetails.useraccesstypeid != 2) {
      return;
    }
    this.toggleSettingsOverlay.emit({isDisplay: false, tabIndex: 0});
    localStorage.setItem('settingsUserAccess', 'Success');
    let obj = {'teamAccessMember': true, data: []};
    this.sharedService.teamAccessMemberData.next(obj);
    localStorage.removeItem('teamMemberData');
    this.router.navigate(['/dashboard/members/team/add']);
  }

  addClient() {
    this.clientService.selectedClient.next(null);
    this.toggleSettingsOverlay.emit({isDisplay: false, tabIndex: 0});
    this.router.navigate(['/dashboard/members/clients/i'])
      .then(() => this.engService.engNavigationStarted$.next(null));
  }

  onChangeTab(tabindex) {
    this.tabIndexValue = tabindex;
    if (tabindex === 0) {
      this.bindMatGrid(this.teamAccessData, 'ALL');
    }
  }

  bindMatGrid(data, type?: 'ALL' | 'Clients') {
    if (type === 'ALL') {
      this.teamMembers = new MatTableDataSource(data);
    } else if (type === 'Clients') {
      this.clients = new MatTableDataSource(data);
    }
  }

  sortData(sort: Sort) {
    let sortData = this.teamAccessData;    
    const data = (sortData).slice();
    if (!sort.active || sort.direction === '') {
      if (this.tabIndexValue == 0) {
        this.teamMembers.data = data;
      } else if (this.tabIndexValue == 1) {
        this.clients.data = data;
      }
      return;
    }
    sortData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'fullname':
          return this.compare(a.fullname, b.fullname, isAsc);
        case 'useraccessname':
          return this.compare(a.useraccessname, b.useraccessname, isAsc);
        case 'title':
          return this.compare(a.title, b.title, isAsc);
        case 'status':
          return this.compare(a.status, b.status, isAsc);
        default:
          return 0;
      }
    });
    this.bindMatGrid(sortData, 'ALL');
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  // delete cms team member
  deleteMemberConfirmation(element: any, dialogType: DIALOG_TYPES) {
    const config = {
      data: {
        dialogType: dialogType,
        dialogHeader: '',
        data: ''
      },
      disableClose: true,
      id: dialogType
    };
    this.dialog.open(RemoveAndReassignFlexComponent, config).afterClosed().subscribe(result => {
      if (result === 'reassign') {
        this.router.navigate(['/dashboard/members/team/assign']);
      } else if (result) {
        this.deleteTeamMember(element);
      }
    });
  }

  deleteDialog(teamMember): void {
    if (teamMember.useraccesstypeid == 0) {
      return;
    }
    localStorage.setItem('cmsMember_reassign', JSON.stringify(teamMember));
    if (teamMember.useraccountroleid === 11) {
      if (teamMember.only_cms_user === 1) {
        this.deleteMemberConfirmation(teamMember, 'delete_CMS_one'); // if only one team member assigned to this CMS
                                                                     // member
      } else if (teamMember.cms_user_assigned_count === 0) {
        // if no active engagements are not assigned to this selected CMS member
        this.deleteMemberConfirmation(teamMember, 'delete_CMS_no_eng_assigned');
      } else {
        this.deleteMemberConfirmation(teamMember, 'delete_CMS_without_reassigned');
      }
    } else {
      this.deleteMemberConfirmation(teamMember, 'not_cms_member');
    }
  }

  private updateSpinnerConfig(value: boolean) {
      value ? this.spinCount++ : (this.spinCount = Math.max(0, this.spinCount - 1));
      const spinner = this.spinnerConfig();
      this.spinnerConfig.set({
       ...spinner,
         isSpinShown: this.spinCount > 0
       });

       const spinnertab = this.spinnerConfigTab();
       this.spinnerConfigTab.set({
         ...spinnertab,
         isSpinShown: this.spinCount > 0
       });
     }

  private loadClientsData() {
    this.clientService.getAllClientsBasicInfo()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (clientsInfo) => {
        // Create a new map with engCount = 0 added to each client
        this.datasourceMap = new Map<number, ClientModel>(
          Array.from(clientsInfo.entries()).map(([key, client]) => {
            return [key, { ...client, engCount: 0 }];
          })
        );          
          this.datasource.data = Array.from(this.datasourceMap.values());    
          this.clientsCount.set(this.datasource.data.length);
          this.loadClientsOtherData().subscribe();
        },
        error: (error) => {
          this.toastr.error(error);
        }
      });
  }

  private loadClientsOtherData(): Observable<void> {
    return of(null).pipe(delay(0), tap(() => {
      this.loadEmails().subscribe();
      this.loadAssignedTeamAndPartners().subscribe();
      this.loadEngCounts().subscribe();
    }))
  }

  private loadEmails(): Observable<void> {
    return of(null).pipe(delay(0), tap(() => {
      this.clientService.getAllClientsEmail().subscribe(res => {
        res?.forEach((email, clientFirm) => {
          this.datasourceMap.get(clientFirm).email = email;
        });
      });
    }));
  }
 
  private loadAssignedTeamAndPartners(refresh: boolean = false): Observable<void> {
    return of(null).pipe(delay(0), tap(() => {
      combineLatest([
        this.loadAssignedPartnersInfo(refresh),
        this.loadAssignedTeamsInfo(refresh)
      ]).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe(() => {
        // unassigned clients
        const assignedClients: number[] = [...this.partnersAssigned.keys(), ...this.teamAssigned.keys()];
        this.unassignedClientsId = new Set(
          Array.from(this.datasourceMap.keys()).filter(clientFirm => !assignedClients.includes(clientFirm))
        );
      });
    }));
  }

  private loadAssignedPartnersInfo(refresh: boolean = false): Observable<Map<number, ClientAssignedPartnerModel>> {
      if (this.partnersAssigned && this.partnersAssigned.size > 0 && !refresh) {
        return of(this.partnersAssigned);
      }
      return this.clientService.getCurrentAssignedPartners().pipe(map(res => {
        this.partnersAssigned = res;
        res?.forEach((item, clientFirm) => {
          if (this.datasourceMap.has(clientFirm)) {
            this.datasourceMap.get(clientFirm).partner = item;
          }
        });
        return this.partnersAssigned;
      }));
    }
  
  private loadAssignedTeamsInfo(refresh: boolean = false): Observable<Map<number, ClientAssignedTeamModel>> {
      if (this.teamAssigned && this.teamAssigned.size > 0 && !refresh) {
        return of(this.teamAssigned);
      }
      return this.clientService.getCurrentAssignedTeamsInfo().pipe(map(res => {
        this.teamAssigned = res;
        res?.forEach((item, clientFirm) => {
          if (this.datasourceMap.has(clientFirm)) {
            this.datasourceMap.get(clientFirm).team = item;
          }
        });
        return this.teamAssigned;
      }));
    }

  private loadEngCounts(): Observable<void> {
    return of(null).pipe(delay(0), tap(() => {
      this.clientService.getEngCounts().subscribe(res => {
        res?.forEach((count, clientFirm) => {
          if (this.datasourceMap.has(clientFirm)) {
            this.datasourceMap.get(clientFirm).engCount = count;
          }
        });
      });
    }));
  }

  trackByClientFirm(_: number, i: ClientModel): number {
    return i.clientFirm;
  }

}
